export enum CollectionPath {
  // 한 홈페이지 당 하나씩만 있는 path
  USERS = 'users',
  COUNTERS = 'counters',
  SERIES = 'series',
  BANNER = 'banner',
  BOARD_SET = 'boardSet',
  NOTIFICATIONS = 'notifications',
  MEMBERTITLE = 'memberTitle',
  THEMEMANAGER = 'themeManager',
  EVENT = 'event',
  SETTING = 'setting',
  SLIDE = 'slide',
  CHALLENGE = 'challenge',
  CHAT = 'chat',
  STICKERBOARD = 'stickerboard',
  STICKERBOARDS = 'stickerboards',
  GLOBAL_STICKERS = 'globalStickers',
  GALLERY = 'gallery',
  ITEM_HISTORY = 'itemHistory',
  STORE = 'store',
  STORENPC = 'storeNpc',
  LUCKYDRAW = 'luckyDraw',
  NPC = 'npc',
  STATUS = 'status',
  CHARACTER_STATUS_EFFECT_DEFINITIONS = 'characterStatusEffectDefinitions',
  CHARACTER_STATUS_EFFECTS = 'characterStatusEffects',
  WALLET_HISTORY = 'walletHistory',
  SKILLS = 'skills',
  EQUIPMENT = 'equipment',
  CALCULATE = 'calculate',
  ROLLPLAY = 'rollplay',
  EXPLORATION = 'exploration',
  RAID = 'raid',
  WORLDMAP = 'worldmap',
  CAMP = 'camp',
  STORY = 'story',
  JUKEBOX = 'jukebox',
  PET = 'pet',
  PETSETTING = 'petSetting',
  QUEST = 'quest',
  QUEST_LOG = 'questLog', // 퀘스트 로그 (미션 타임라인)
  QUEST_LOG_COMMENT = 'questLogComment', // 퀘스트 로그 댓글
  BANNER_GROUP = 'bannerGroup',
  BETTING = 'betting',
  DEMO_BETTING = 'demoBetting',
  WIKI = 'wiki',
  CUSTOM_BOTS = 'customBots', // 커스텀 봇
  PROFILE_TEMPLATE = 'profileTemplate', // 프로필 템플릿
  USER_LEAVE = 'userLeave', // 멤버 탈퇴 히스토리
  MEMBER_GROUPS = 'memberGroups', // 재화 지급 등에서 사용하는 멤버 그룹(라벨)

  // 유동적 path
  CLOSET = 'closet',
  CLOSET_ALBUM = 'album',
  CLOSET_POSTING = 'photocardPosting',
  POSTING = 'posting',
  PHOTOCARD = 'photocard',
  MAINHOME = 'mainHome',
  SLIDEHOME = 'home',
  CALENDAR = 'calendar',
  HISTORY = 'history',
  TIMELINE = 'timeline',
  FORM = 'form',
  // 🔨 조합식 관련 컬렉션
  CRAFTING_RECIPES = 'craftingRecipes', // 조합식 마스터 데이터
  USER_CRAFTING_PROGRESS = 'userCraftingProgress', // 사용자별 조합 진행 상태
  CRAFTING_STATS = 'craftingStats', // 조합식 통계 (선택사항)
  CRAFTING_SUCCESS_PROOF = 'craftingSuccessProof', // 유저별 Timeline 레시피 성공 증명
}

export enum SettingCollectionPath {
  JUKEBOX = 'setting/jukebox',
  HOMEPAGE = 'setting/homepageSetting',
  FONT_MANAGER = 'setting/fontManager',
  MOUSE = 'setting/mouse',
  SOUNDEFFECT = 'setting/soundEffect',
  BACKGROUNDEFFECT = 'setting/backgroundEffect',
  SHOOTINGSTAREFFECT = 'setting/shootingstarEffect',
  STICKERBOARD = 'setting/stickerboard',
  GLOBAL_STICKERS = 'setting/globalStickers',
  SUBMENU = 'setting/subMenu',
  GAMEUI = 'setting/gameUi',
  EXPLORATION = 'setting/exploration',
  WORLDMAP = 'setting/worldmap',
  PHOTOCARD = 'setting/photocard',
  PET = 'setting/pet',
  CAMP = 'setting/camp',
  QUEST = 'setting/quest',
  RAID = 'setting/raid',
  BETTING = 'setting/betting',
  WIKI = 'setting/wiki',
  TIMELINE = 'setting/timeline',
  THREADS = 'setting/threads',
  GUESTBOOK = 'setting/guestbook',
  POPUP = 'setting/popup',
  USER_ACCOUNT_TAB = 'setting/userAccountTab',
  EMBED = 'setting/embed',
}

export enum SubColPath {
  TODOLIST = 'todoList',
  CHATLIST = 'chatList',
  MEMOLIST = 'memoList',
  ACCOUNTS = 'accounts',
}

export enum ImainhomeDoc {
  MAINHOME = 'mainHome',
  GATEPAGE = 'gatePage',
  WORLDPAGE = 'worldPage',
  HISTORYPAGE = 'historyPage',
  ASIDE = 'aside',
  MAINMENU = 'mainMenu',
}
